var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.926,
    height: 28,
    viewBox: "0 0 27.926 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37906",
    "data-name": "Path 37906",
    d: "M26.213,27.664H22.995a.7.7,0,0,1,0-1.4h1.794V2.17H5.876V26.264H16.16a.7.7,0,0,1,0,1.4H4.48V.77H26.213Z",
    transform: "translate(-1.352 -0.231)",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37907",
    "data-name": "Path 37907",
    d: "M17.133,10.98H9.7a.7.7,0,0,1,0-1.4h7.47a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-2.717 -2.874)",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37908",
    "data-name": "Path 37908",
    d: "M28.262,10.98H26.4a.7.7,0,0,1,0-1.4h1.864a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-7.758 -2.874)",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37909",
    "data-name": "Path 37909",
    d: "M17.133,17.05H9.7a.7.7,0,0,1,0-1.4h7.47a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-2.717 -4.695)",
    fill: "#979797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37910",
    "data-name": "Path 37910",
    d: "M28.262,17.05H26.4a.7.7,0,0,1,0-1.4h1.864a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-7.758 -4.695)",
    fill: "#979797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37911",
    "data-name": "Path 37911",
    d: "M17.133,23.12H9.7a.7.7,0,0,1,0-1.4h7.47a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-2.717 -6.516)",
    fill: "#979797"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37912",
    "data-name": "Path 37912",
    d: "M28.262,23.12H26.4a.7.7,0,0,1,0-1.4h1.864a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-7.758 -6.516)",
    fill: "#979797"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3052",
    "data-name": "Rectangle 3052",
    width: 28,
    height: 27.926,
    transform: "translate(0 28) rotate(-90)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.6c58fbec96d5b771fdc39aca72e55704.svg";
export { ForwardRef as ReactComponent };